import { useEffect, useState } from 'react';
import StrategyOverview from './StrategyOverview';
import StrategyOverviewViewOnly from '../shared/StrategyOverviewViewOnly';

export default function StrategyOverviewWrapper({
  ownerObj,
  ownerDefaultValue,
  masterOwnerUserList,
  masterApproverUserList,
  approverDefaultValue,
  readOnly,
  strategyInformation,
  commonProps,
  hasUSScope,
  userInfoMap,
  selectedOverviewViewList,
  setSelectedOverviewViewList,
  forCreate,
  isNewForm,
  setIsStrategyOverviewDirty
}) {
  const [enableEdit, setEnableEdit] = useState(null);
  const [enableView, setEnableView] = useState(null);

  useEffect(() => {
    if (enableEdit && selectedOverviewViewList) {
      commonProps.setValue('ownerId', selectedOverviewViewList.ownerId ?? '', {
        shouldValidate: true
      });
      commonProps.setValue(
        'approverId',
        selectedOverviewViewList.approverId ?? '',
        { shouldValidate: true }
      );
      commonProps.setValue(
        'strategyDesc',
        selectedOverviewViewList.strategyDesc ?? '',
        { shouldValidate: true }
      );
    }
  }, [enableEdit, selectedOverviewViewList]);

  function editOverview(e) {
    e.preventDefault();
    setEnableEdit(true);
    setEnableView(false);
  }

  function viewOverView(e) {
    if (
      !commonProps.errors ||
      (commonProps.errors &&
        !commonProps.errors.ownerId &&
        !commonProps.errors.approverId)
    ) {
      e.preventDefault();
      // Capture values synchronously while StrategyOverview is still mounted
      // (Controller unregisters fields on unmount, so watchFields becomes stale)
      const ownerId = commonProps.getValues('ownerId');
      const approverId = commonProps.getValues('approverId');
      const strategyDesc = commonProps.getValues('strategyDesc');
      setSelectedOverviewViewList((prev) => ({
        ...prev,
        ownerId: ownerId ?? prev?.ownerId,
        approverId: approverId ?? prev?.approverId,
        strategyDesc: strategyDesc ?? prev?.strategyDesc
      }));
      setEnableView(true);
      setEnableEdit(false);
    }
  }

  return (
    <>
      {isNewForm || enableEdit || commonProps.strategyNumber === 0 ? (
        <StrategyOverview
          ownerObj={ownerObj}
          ownerDefaultValue={ownerDefaultValue}
          masterOwnerUserList={masterOwnerUserList}
          masterApproverUserList={masterApproverUserList}
          control={commonProps.control}
          approverDefaultValue={approverDefaultValue}
          readOnly={readOnly}
          strategyInformation={strategyInformation}
          commonProps={commonProps}
          hasUSScope={hasUSScope}
          isNewForm={isNewForm}
          isEdit={commonProps.isEdit}
          viewOverView={viewOverView}
          selectedOverviewViewList={selectedOverviewViewList}
          forCreate={forCreate}
          setIsStrategyOverviewDirty={setIsStrategyOverviewDirty}
        />
      ) : (
        (enableView || selectedOverviewViewList) && (
          <StrategyOverviewViewOnly
            key={selectedOverviewViewList}
            strategyInformation={strategyInformation}
            userInfoMap={userInfoMap}
            isEdit={commonProps.isEdit}
            isNewForm={isNewForm}
            editOverview={editOverview}
            selectedOverviewViewList={selectedOverviewViewList}
          />
        )
      )}
    </>
  );
}
